"use client";

import { useMemo } from "react";

const timeFormatter = new Intl.DateTimeFormat("vi", { dateStyle: "long" });

export function Realtime() {
	const currentDate = useMemo(() => timeFormatter.format(Date.now()), []);

	return (
		<span className="w-max text-sm" suppressHydrationWarning>
			{currentDate}
		</span>
	);
}
